import stls from '@f_qwep/styles/component/settings/Suppliers.module.sass';
import { Link } from '@mui/material';

export function CellSite({ info }: any) {
    return (
        <Link target={'_blank'} className={stls.cellSite} href={info.row.original.site} underline="always">
            <p className={stls.text}>{info.row.original.site}</p>
        </Link>
    );
}
